import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TreeSelect } from 'antd';
import { TreeItem } from '@martech-solution/utils/types';
import { buildHierarchySelect } from 'src/utils/collection';
import { getDepartmentsDropdown } from 'src/apis/master_data/department.api';

interface Props {
  value?: number | undefined;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: number | undefined, label: React.ReactNode[]) => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  isShowsOptionNull?: boolean;
  popupMatchSelectWidth?: boolean | number | undefined;
}

export default function DepartmentTreeSelect({
  value,
  style,
  allowClear = true,
  onChange,
  disabled,
  className,
  placeholder,
  isShowsOptionNull,
  popupMatchSelectWidth
}: Props) {
  const [departmentTreeItem, setDepartmentTreeItem] = useState<TreeItem[] | undefined>(undefined);

  const departmentsDropdownQuery = useQuery({
    queryKey: ['departmentsTreeDropdown'],
    queryFn: () => getDepartmentsDropdown(),
    staleTime: 60 * 1000 * 60
  });

  useEffect(() => {
    const result = buildHierarchySelect(departmentsDropdownQuery.data?.data);
    if (result && isShowsOptionNull) {
      result?.unshift({
        key: 0,
        value: '0',
        title: 'Không có bộ phận',
        children: []
      });
    }

    setDepartmentTreeItem(result);
  }, [departmentsDropdownQuery.data?.data, isShowsOptionNull]);

  return (
    <TreeSelect
      popupMatchSelectWidth={popupMatchSelectWidth ?? 400}
      treeLine={true}
      value={departmentsDropdownQuery.isFetching ? undefined : value}
      disabled={disabled}
      showSearch
      placement='bottomLeft'
      placeholder={placeholder}
      className={className}
      style={style}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      treeNodeFilterProp='value'
      allowClear={allowClear}
      onChange={onChange}
      treeData={departmentTreeItem}
      loading={departmentsDropdownQuery.isFetching}
      filterTreeNode={(inputValue, treeNode) => {
        return treeNode.title?.toString().toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) ?? false;
      }}
    />
  );
}
